module.exports = __webpack_public_path__ + "img/Cpanel.ab2c1a6.svg";